export const parseMfbParts = (value) => {
  if (typeof value !== "string" || !value.length) {
    return [];
  }

  const rawSegments = [];
  const tokenRegex = /[^\s]+/g;
  let lastIndex = 0;
  let match;

  while ((match = tokenRegex.exec(value)) !== null) {
    const token = match[0];
    const index = match.index;

    if (index > lastIndex) {
      const textChunk = value.slice(lastIndex, index);

      if (textChunk.length) {
        rawSegments.push({ type: "text", value: textChunk });
      }
    }

    if (token.includes("/")) {
      const options = token
        .split("/")
        .map((option) => option.trim())
        .filter((option) => option.length);

      rawSegments.push({ type: "dropdown", value: options.length ? options : [""] });
    } else {
      rawSegments.push({ type: "text", value: token });
    }

    lastIndex = index + token.length;
  }

  if (lastIndex < value.length) {
    const trailingText = value.slice(lastIndex);

    if (trailingText.length) {
      rawSegments.push({ type: "text", value: trailingText });
    }
  }

  const mergedSegments = rawSegments.reduce((acc, segment) => {
    if (segment.type === "text") {
      const previous = acc[acc.length - 1];

      if (previous && previous.type === "text") {
        previous.value += segment.value;
      } else {
        acc.push({ ...segment });
      }
    } else {
      acc.push({ ...segment });
    }

    return acc;
  }, []);

  return mergedSegments.map((segment) =>
    segment.type === "dropdown" ? segment.value : segment.value
  );
};
